import React from 'react';
import { connect } from 'redux-bundler-react';
import SidebarPanelOpenerButton from './project-sidebar-panel-opener';
import ProjectPanel from './project-panel';

function getClass(type){
  switch(type){
    case 'dam_study': 
      return "ds ds-damicon icon-inline";
    case "levee_study":
      return "ds ds-levee icon-inline";
    case "cwms": 
      return "ds ds-cwms icon-inline";
    case "silver_jackets":
      return "ds ds-silver-jackets icon-inline";
    case "fema":
      return "ds ds-fema icon-inline";
    case "flood_fight":
      return "ds ds-flood-fight icon-inline";
    case "simdams":
      return "mdi mdi-database icon-inline";
    default:
      return "mdi mdi-map icon-inline";
  }
}

class DsButton extends React.Component {
  constructor(props){
    super(props);

    const { dsType } = this.props;

    this.state = {
      libraryId: props.library.LIBRARY_ID,
      libraryType: props.library.LIBRARY_TYPE,
      type: dsType
    }
  }
  
  render() {
    const { library } = this.props;
    const { datasets, libraryType } = this.state;
    return (
      <SidebarPanelOpenerButton
        iconClass={getClass(library.LIBRARY_TYPE)}
        iconText={library.NAME.substr(0,2)}
        styleOverride={{maxWidth:'62px'}}
        label={`Project ${library.NAME}`}
        title={`${libraryType} ${library.NAME}`}
        panelComponent={ ProjectPanel }
        panelOptions={{library: library, datasets: datasets}}
        open={true}
      />
    );
  }
}

export default connect(
  'doOpenPrimaryPanel',
  'doDSCreateRootNode',
  'doDSLoadLayers',
  DsButton
);